import React from 'react';
import "../../AdminComponents/QuizPerformanceTable/QuizPerformanceTable.scss";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useAppSelector } from '../../../Store/store';

function createData(
    name: string,
    score: string,
    date: string,
  ) {
    return { name, score, date, };
  }
  
  const rows = [
    createData('Mathematics Assessment', "95%", "Mar 15, 2025"),
    createData('Physics Quiz', "88%", "Mar 12, 2025"),
  ];

const QuizPerformanceTable = ({ quizPerformance }: { quizPerformance: any[] }) => {
  function formatDate(dateString:any) {
    const date = new Date(dateString);
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    
    return `${month} ${day}, ${year}`;
  }

  return (
    <>  
    <div className='quiz-table-wrap'>
    <TableContainer >
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Quiz Name</TableCell>
            <TableCell align="center">Score</TableCell>
            <TableCell align="center">Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {quizPerformance.map((x:any,index:any) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {x?.lesson_name}
              </TableCell>
              <TableCell align="center">{x?.percentage}</TableCell>
              <TableCell className='date-td-cell' align="center">{formatDate(x?.answered_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
    </>
  )
}

export default QuizPerformanceTable